import React, { useCallback, useEffect, useRef, useState } from "react";
import changeToSentecesText from "../../../util/changeToSentecesText";
import { ChevronDownDDS } from "../../../asset";

const ArrMaritalStatus = ["Lajang", "Nikah", "Cerai"];

const DropdownListMaritalStatus = ({
  setValueDDS,
  children,
  valueDDS,
  className,
  togglerClassName,
  placeholder,
  ...attrs
}) => {
  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [dataSelected, setDataSelected] = useState();

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const onClickDataSelected = useCallback(
    (data) => {
      setDataSelected(data);
      setIsShowDropdownContent(false);
      setValueDDS(data);
    },
    [setValueDDS]
  );

  useEffect(() => {
    if (!valueDDS || valueDDS === null) {
      setDataSelected();
      return;
    }
    if (valueDDS) {
      setDataSelected(valueDDS);
      setValueDDS(valueDDS);
    }
    return;
  }, [setValueDDS, valueDDS]);

  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="w-full border border-gray-200 bg-white-100 flex justify-between px-[6px] rounded-md h-[40px] items-center"
        onClick={togglerDropdownContent}
      >
        <span
          className={"font-roboto text-xl text-black-300 font-medium px-2 truncate".concat(
            !dataSelected ? " text-opacity-50" : ""
          )}
        >
          {dataSelected ? changeToSentecesText(dataSelected) : placeholder}
        </span>
        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </button>
      <div></div>
      <div
        className={"dropdown-menu".concat(
          isShowDropdownContent ? " active mt-5" : ""
        )}
        ref={dropdownContentRef}
      >
        <ul className="overflow-auto max-h-[300px]">
          {ArrMaritalStatus.map((el, index) => (
            <li
              key={index}
              className="dropdown-item truncate"
              onClick={() => {
                onClickDataSelected(el);
              }}
            >
              {changeToSentecesText(el)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DropdownListMaritalStatus;
